document.addEventListener("DOMContentLoaded", function () {

  // -----------------------------------------------
  // 1. Smooth Scroll for anchor links
  // -----------------------------------------------
  document.querySelectorAll('a.scroll-link').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#') + 1) : null;
      var targetEl = hash ? document.getElementById(hash) : null;
      if (targetEl) {
        e.preventDefault();
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      // Wenn Element nicht auf dieser Seite → normale Navigation (Browser scrollt nach Laden)
    });
  });

  // Nach Seitenload: falls Hash in URL, zu Element scrollen
  if (window.location.hash) {
    var hashEl = document.getElementById(window.location.hash.substring(1));
    if (hashEl) {
      setTimeout(function () {
        hashEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  }

  // -----------------------------------------------
  // 2. Scroll Reveal Animations
  // -----------------------------------------------
  var reveals = document.querySelectorAll('.reveal');
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
      }
    });
  }, {
    root: null,
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  });
  reveals.forEach(function (el) { revealObserver.observe(el); });

  // -----------------------------------------------
  // 3. Mobile Menu & Cart Drawer
  // -----------------------------------------------
  var mobileMenuBtn     = document.getElementById('mobile-menu-btn');
  var mobileMenuWrapper = document.getElementById('mobile-menu-wrapper');
  var mobileMenuIcon    = document.getElementById('mobile-menu-icon');
  var mobileLinks       = document.querySelectorAll('.mobile-nav-link');

  var cartToggleBtn     = document.getElementById('cart-toggle-btn');
  var cartWrapper       = document.getElementById('cart-wrapper');
  var cartContainer     = document.getElementById('cart-items-container');

  var isMenuOpen = false;
  var isCartOpen = false;
  var liveCartCount = 0;
  var liveCartTotal = 0;
  var liveCartWeight = 0;


  function closeMenu() {
    isMenuOpen = false;
    if (mobileMenuWrapper) mobileMenuWrapper.style.gridTemplateRows = '0fr';
    if (mobileMenuIcon) {
      mobileMenuIcon.textContent = 'menu';
      mobileMenuIcon.style.transform = 'rotate(0deg)';
    }
    mobileLinks.forEach(function (link) {
      link.classList.remove('opacity-100', 'translate-x-0');
      link.classList.add('opacity-0', 'translate-x-[-20px]');
    });
  }

  function closeCart() {
    isCartOpen = false;
    if (cartWrapper) cartWrapper.style.gridTemplateRows = '0fr';
    document.querySelectorAll('.cart-item').forEach(function (item) {
      item.classList.remove('opacity-100', 'translate-x-0');
      item.classList.add('opacity-0', 'translate-x-[-20px]');
    });
  }

  function showEmptyCartToast() {
    var toast = document.getElementById('empty-cart-msg');
    if (!toast) return;
    toast.classList.remove('translate-y-[-150%]', 'opacity-0');
    toast.classList.add('translate-y-0', 'opacity-100');
    setTimeout(function () {
      toast.classList.remove('translate-y-0', 'opacity-100');
      toast.classList.add('translate-y-[-150%]', 'opacity-0');
    }, 3000);
  }

  var lastCartClickTime = 0;
  function showSlowDownToast() {
    var toast = document.getElementById('cart-slow-down-msg');
    if (!toast) return;
    toast.classList.remove('translate-y-[-150%]', 'opacity-0');
    toast.classList.add('translate-y-0', 'opacity-100');
    setTimeout(function () {
      toast.classList.remove('translate-y-0', 'opacity-100');
      toast.classList.add('translate-y-[-150%]', 'opacity-0');
    }, 2500);
  }

  // -----------------------------------------------
  // Shopify AJAX Cart API
  // -----------------------------------------------

  function formatMoney(cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderCartItems(items, skipAnimation) {
    if (!cartContainer) return;
    if (!items || items.length === 0) {
      cartContainer.innerHTML = '<div class="flex flex-col items-center justify-center py-10">'
        + '<span class="material-symbols-outlined text-[48px] text-slate-200 mb-2">shopping_cart</span>'
        + '<p class="text-slate-400 text-sm font-medium">Dein Warenkorb ist leer.</p>'
        + '</div>';
      return;
    }
    var html = '';
    var animClass = skipAnimation ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-[-20px]';
    items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title + '" class="w-full h-full object-cover rounded-lg">'
        : '<span class="material-symbols-outlined text-slate-300 text-[28px]">image</span>';
      html += '<div class="cart-item ' + animClass + ' transition-all duration-300 flex items-center gap-3 py-3.5 border-b border-slate-200/50" data-unit-price="' + item.price + '" data-grams="' + (item.grams || 0) + '" data-variant-id="' + item.variant_id + '">'
        + '<div class="w-14 h-14 rounded-lg flex items-center justify-center shrink-0 overflow-hidden">'
        + imgHtml
        + '</div>'
        + '<div class="flex-1 min-w-0">'
        + '<h5 class="font-headline font-bold text-sm text-on-surface line-clamp-1">' + item.product_title + '</h5>'
        + (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="text-xs text-slate-400 mt-0.5">' + item.variant_title + '</p>' : '')
        + '<div class="flex justify-between items-center mt-1.5">'
        + '<span class="text-primary font-bold text-sm">' + formatMoney(item.final_line_price) + '</span>'
        + '<div class="flex items-center gap-2">'
        + '<button class="cart-minus w-7 h-7 flex items-center justify-center text-slate-400 hover:text-primary hover:bg-blue-50 rounded-lg transition-colors" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '"><span class="material-symbols-outlined text-[16px]">remove</span></button>'
        + '<span class="text-xs font-bold w-5 text-center">' + item.quantity + '</span>'
        + '<button class="cart-plus w-7 h-7 flex items-center justify-center text-slate-400 hover:text-primary hover:bg-blue-50 rounded-lg transition-colors" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '"><span class="material-symbols-outlined text-[16px]">add</span></button>'
        + '<button class="cart-remove w-7 h-7 flex items-center justify-center text-slate-300 hover:text-red-400 rounded-lg transition-colors ml-2" data-key="' + item.key + '" data-qty="0" aria-label="Artikel entfernen"><span class="material-symbols-outlined text-[16px]">delete</span></button>'
        + '</div></div></div></div>';
    });
    cartContainer.innerHTML = html;

    cartContainer.querySelectorAll('.cart-minus, .cart-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var now = Date.now();
        if (now - lastCartClickTime < 600) {
          showSlowDownToast();
          return;
        }
        lastCartClickTime = now;
        var key        = this.getAttribute('data-key');
        var qty        = parseInt(this.getAttribute('data-qty'), 10);
        var isIncrease = this.classList.contains('cart-plus');
        var cartItem   = this.closest('.cart-item');
        var variantId  = cartItem ? parseInt(cartItem.getAttribute('data-variant-id'), 10) : null;
        changeCartItem(key, qty, variantId, isIncrease);
      });
    });

    cartContainer.querySelectorAll('.cart-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key      = this.getAttribute('data-key');
        var cartItem = this.closest('.cart-item');
        var variantId = cartItem ? parseInt(cartItem.getAttribute('data-variant-id'), 10) : null;
        changeCartItem(key, 0, variantId, false);
      });
    });
  }

  function updateCartHeader(cart) {
    var countText = document.getElementById('cart-count-text');
    var badge     = document.getElementById('cart-badge');
    var totalEl   = document.getElementById('cart-total-price');
    liveCartCount = cart.item_count;
    liveCartTotal = cart.total_price;
    if (countText) countText.innerText = liveCartCount;
    if (badge)     badge.innerText = liveCartCount;
    if (totalEl)   totalEl.innerText = formatMoney(liveCartTotal);
    try { localStorage.setItem('eka_cart_count', liveCartCount); } catch(e) {}
  }

  function updateCartHeaderOptimistic(countDelta, priceDelta) {
    liveCartCount = Math.max(0, liveCartCount + countDelta);
    liveCartTotal = Math.max(0, liveCartTotal + priceDelta);
    var countText = document.getElementById('cart-count-text');
    var badge     = document.getElementById('cart-badge');
    var totalEl   = document.getElementById('cart-total-price');
    if (countText) countText.innerText = liveCartCount;
    if (badge)     badge.innerText = liveCartCount;
    if (totalEl)   totalEl.innerText = formatMoney(liveCartTotal);
    try { localStorage.setItem('eka_cart_count', liveCartCount); } catch(e) {}
  }

  function updateWeightOptimistic(gramsDelta) {
    if (!weightLimitEnabled) return;
    liveCartWeight = Math.max(0, liveCartWeight + gramsDelta);
    var weightDisplay = document.getElementById('cart-weight-display');
    if (weightDisplay) weightDisplay.textContent = formatWeight(liveCartWeight);
    var warningEl = document.getElementById('cart-weight-warning');
    var checkoutBtn = document.getElementById('cart-checkout-btn');
    var speditionBtn = document.getElementById('cart-spedition-btn');
    var isOverweight = liveCartWeight > weightLimitGrams;
    if (warningEl) { warningEl.classList.toggle('hidden', !isOverweight); warningEl.classList.toggle('flex', isOverweight); }
    if (checkoutBtn) checkoutBtn.classList.toggle('hidden', isOverweight);
    if (speditionBtn) { speditionBtn.classList.toggle('hidden', !isOverweight); speditionBtn.classList.toggle('flex', isOverweight); }
  }

  // Badge sofort mit gespeicherter Zahl füllen (vor API-Call)
  try {
    var savedCount = localStorage.getItem('eka_cart_count');
    if (savedCount !== null) {
      var badge = document.getElementById('cart-badge');
      var countText = document.getElementById('cart-count-text');
      if (badge) badge.innerText = savedCount;
      if (countText) countText.innerText = savedCount;
    }
  } catch(e) {}

  function fetchCart(callback) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartHeader(cart);
        checkWeightLimit(cart);
        if (callback) callback(cart);
      });
  }

  function addToCart(variantId, qty, btn) {
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      var cartIcon = document.getElementById('cart-icon');
      if (cartIcon) {
        cartIcon.classList.add('cart-bounce');
        setTimeout(function () { cartIcon.classList.remove('cart-bounce'); }, 300);
      }
      fetchCart(function (cart) {
        renderCartItems(cart.items, true);
      });
    })
    .catch(function () {
      showEmptyCartToast();
    })
    .finally(function () {
      if (btn) btn.disabled = false;
    });
  }

  function syncCartFromServer(cart) {
    if (!cart || cart.item_count === undefined) return;
    updateCartHeader(cart);
    checkWeightLimit(cart);
    if (cart.item_count === 0) {
      renderCartItems(cart.items, true);
      closeCart();
    }
  }

  function changeCartItem(key, qty, variantId, isIncrease) {
    // Optimistisches UI-Update
    var items = cartContainer.querySelectorAll('.cart-item');
    items.forEach(function (item) {
      var minusBtn = item.querySelector('.cart-minus');
      if (minusBtn && minusBtn.getAttribute('data-key') === key) {
        var unitPrice = parseInt(item.getAttribute('data-unit-price') || '0', 10);
        var itemGrams  = parseInt(item.getAttribute('data-grams') || '0', 10);
        var prevQty    = parseInt(minusBtn.getAttribute('data-qty'), 10) + 1;
        var qtyDelta   = qty - prevQty;
        if (qty <= 0) {
          item.style.transition = 'opacity 0.2s, transform 0.2s';
          item.style.opacity = '0';
          item.style.transform = 'translateX(-20px)';
          setTimeout(function () { item.remove(); }, 200);
          updateCartHeaderOptimistic(-prevQty, -(unitPrice * prevQty));
          updateWeightOptimistic(-(itemGrams * prevQty));
        } else {
          var qtySpan = item.querySelector('.text-xs.font-bold.w-5');
          if (qtySpan) qtySpan.textContent = qty;
          var priceSpan = item.querySelector('.text-primary.font-bold.text-sm');
          if (priceSpan && unitPrice > 0) priceSpan.textContent = formatMoney(unitPrice * qty);
          minusBtn.setAttribute('data-qty', qty - 1);
          var plusBtn = item.querySelector('.cart-plus');
          if (plusBtn) plusBtn.setAttribute('data-qty', qty + 1);
          updateCartHeaderOptimistic(qtyDelta, unitPrice * qtyDelta);
          updateWeightOptimistic(itemGrams * qtyDelta);
        }
      }
    });

    if (isIncrease) {
      // + Klick: /cart/add.js (identisch mit "In den Warenkorb" – funktioniert garantiert)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () { fetchCart(syncCartFromServer); });
    } else {
      // - Klick oder Entfernen: /cart/change.js mit absoluter Menge
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        syncCartFromServer(cart);
        if (qty <= 0) renderCartItems(cart.items, true);
      });
    }
  }

  function animateCartItemsIn() {
    document.querySelectorAll('.cart-item').forEach(function (item, index) {
      setTimeout(function () {
        item.classList.remove('opacity-0', 'translate-x-[-20px]');
        item.classList.add('opacity-100', 'translate-x-0');
      }, 50 + (index * 60));
    });
  }

  // Seite laden: aktuellen Warenkorbstand abrufen
  fetchCart(function (cart) {
    renderCartItems(cart.items);
  });

  // Add-to-Cart Buttons auf Produktkarten
  function attachAddToCartListeners() {
    document.querySelectorAll('.add-to-cart-btn').forEach(function (btn) {
      if (btn._addToCartBound) return;
      btn._addToCartBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;
        addToCart(variantId, 1, this);
      });
    });
  }
  attachAddToCartListeners();

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', function () {
      if (isCartOpen) closeCart();
      isMenuOpen = !isMenuOpen;
      if (isMenuOpen) {
        mobileMenuWrapper.style.gridTemplateRows = '1fr';
        mobileMenuIcon.textContent = 'close';
        mobileMenuIcon.style.transform = 'rotate(90deg)';
        mobileLinks.forEach(function (link, index) {
          setTimeout(function () {
            link.classList.remove('opacity-0', 'translate-x-[-20px]');
            link.classList.add('opacity-100', 'translate-x-0');
          }, 150 + (index * 100));
        });
      } else {
        closeMenu();
      }
    });
  }

  if (cartToggleBtn) {
    cartToggleBtn.addEventListener('click', function () {
      if (isMenuOpen) closeMenu();
      isCartOpen = !isCartOpen;
      if (isCartOpen) {
        fetchCart(function (cart) {
          if (cart.item_count === 0) {
            showEmptyCartToast();
            isCartOpen = false;
            return;
          }
          renderCartItems(cart.items);
          if (cartWrapper) cartWrapper.style.gridTemplateRows = '1fr';
          animateCartItemsIn();
        });
      } else {
        closeCart();
      }
    });
  }

  // -----------------------------------------------
  // 4. FAQ Accordion
  // -----------------------------------------------
  document.querySelectorAll('.faq-button').forEach(function (button) {
    button.addEventListener('click', function () {
      var currentContent = button.nextElementSibling;
      var currentIcon    = button.querySelector('.faq-icon');
      var isOpen         = currentContent.classList.contains('open');

      document.querySelectorAll('.faq-content').forEach(function (c) { c.classList.remove('open'); });
      document.querySelectorAll('.faq-icon').forEach(function (icon) {
        icon.style.transform = 'rotate(0deg)';
        icon.textContent = 'add_circle';
        icon.classList.remove('text-primary');
        icon.classList.add('text-slate-400');
      });
      document.querySelectorAll('.faq-button').forEach(function (btn) { btn.classList.remove('text-primary'); });

      if (!isOpen) {
        currentContent.classList.add('open');
        currentIcon.style.transform = 'rotate(180deg)';
        currentIcon.textContent = 'remove_circle';
        currentIcon.classList.remove('text-slate-400');
        currentIcon.classList.add('text-primary');
        button.classList.add('text-primary');
      }
    });
  });

  // -----------------------------------------------
  // 5. Lazy Load GIF – play once & freeze at last frame
  // -----------------------------------------------
  var gifTriggers = document.querySelectorAll('.gif-trigger');
  var gifObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var img = entry.target;
        var gifSrc = img.getAttribute('data-gif-src');
        if (!gifSrc) return;

        // Load GIF as blob so we can draw it on canvas (same-origin)
        fetch(gifSrc)
          .then(function (r) { return r.blob(); })
          .then(function (blob) {
            var blobUrl = URL.createObjectURL(blob);
            img.src = blobUrl;

            // Continuously capture current frame; after GIF ends, canvas keeps last frame
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var captureInterval = setInterval(function () {
              if (img.naturalWidth > 0) {
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                ctx.drawImage(img, 0, 0);
              }
            }, 100);

            // After 6 seconds, freeze at whatever frame was last captured
            setTimeout(function () {
              clearInterval(captureInterval);
              // One final capture
              if (img.naturalWidth > 0) {
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                ctx.drawImage(img, 0, 0);
              }
              try {
                var dataUrl = canvas.toDataURL('image/png');
                img.src = dataUrl;
              } catch (e) {
                // Fallback: leave the GIF running
              }
              URL.revokeObjectURL(blobUrl);
            }, 6000);
          })
          .catch(function () {
            // Fallback: just load the GIF normally
            img.src = gifSrc;
          });

        observer.unobserve(img);
      }
    });
  }, { root: null, threshold: 0.5 });
  gifTriggers.forEach(function (gif) { gifObserver.observe(gif); });

  // -----------------------------------------------
  // 6. Shop – Category & Sort Dropdowns
  // -----------------------------------------------
  function initDropdown(btnId, menuId, arrowId, textId, onChange) {
    var btn   = document.getElementById(btnId);
    var menu  = document.getElementById(menuId);
    var arrow = document.getElementById(arrowId);
    var text  = document.getElementById(textId);
    if (!btn || !menu) return;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = menu.classList.contains('open');
      document.querySelectorAll('.dropdown-menu').forEach(function (m) { m.classList.remove('open'); m.classList.add('hidden'); });
      if (!isOpen) {
        menu.classList.remove('hidden');
        requestAnimationFrame(function () { menu.classList.add('open'); });
        if (arrow) arrow.style.transform = 'rotate(180deg)';
      } else {
        if (arrow) arrow.style.transform = 'rotate(0deg)';
      }
    });

    menu.querySelectorAll('li').forEach(function (li) {
      li.addEventListener('click', function () {
        var value = this.getAttribute('data-filter') || this.textContent.trim();
        if (text) text.textContent = this.textContent.trim();
        menu.querySelectorAll('.material-symbols-outlined').forEach(function (ic) { ic.classList.add('opacity-0'); });
        var check = this.querySelector('.material-symbols-outlined');
        if (check) check.classList.remove('opacity-0');
        menu.classList.remove('open');
        menu.classList.add('hidden');
        if (arrow) arrow.style.transform = 'rotate(0deg)';
        if (onChange) onChange(value);
      });
    });
  }

  // Category dropdown – AJAX: lädt Kollektion ohne Seiten-Reload
  initDropdown('category-dropdown-btn', 'category-dropdown-menu', 'dropdown-arrow', 'selected-category-text', null);

  function attachCategoryAjaxListeners() {
    var categoryMenu = document.getElementById('category-dropdown-menu');
    if (!categoryMenu) return;
    categoryMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var url = this.getAttribute('href');
        if (!url) return;
        var grid = document.getElementById('product-grid-container');
        var countEl = document.getElementById('product-count');
        if (!grid) { window.location.href = url; return; }

        grid.style.opacity = '0.4';
        grid.style.pointerEvents = 'none';

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('product-grid-container');
            if (newGrid) {
              grid.innerHTML = newGrid.innerHTML;
              attachAddToCartListeners();
            }
            var newCount = doc.getElementById('product-count');
            if (newCount && countEl) countEl.textContent = newCount.textContent;
            // Dropdown-Menü mit neuen Haken aus der geholten Seite aktualisieren
            var newCatMenu = doc.getElementById('category-dropdown-menu');
            var currentCatMenu = document.getElementById('category-dropdown-menu');
            if (newCatMenu && currentCatMenu) {
              currentCatMenu.innerHTML = newCatMenu.innerHTML;
              attachCategoryAjaxListeners();
            }
            // Dropdown-Label aktualisieren
            var labelEl = document.getElementById('selected-category-text');
            if (labelEl) labelEl.textContent = this.textContent.trim();
            grid.style.opacity = '1';
            grid.style.pointerEvents = '';
            history.pushState(null, '', url);
          }.bind(this))
          .catch(function () {
            grid.style.opacity = '1';
            grid.style.pointerEvents = '';
            window.location.href = url;
          });
      });
    });
  }
  attachCategoryAjaxListeners();

  // Sort-Option aktiv markieren
  function updateActiveSortOption(sortByValue) {
    document.querySelectorAll('.sort-option[data-sort-by]').forEach(function (opt) {
      var isActive = opt.getAttribute('data-sort-by') === sortByValue;
      opt.classList.toggle('text-primary', isActive);
      opt.classList.toggle('font-bold', isActive);
      opt.classList.toggle('text-slate-600', !isActive);
      opt.classList.toggle('font-medium', !isActive);
    });
  }

  // Beim Seitenload aktive Sort-Option aus URL lesen
  (function () {
    var params = new URLSearchParams(window.location.search);
    var currentSort = params.get('sort_by') || 'manual';
    var knownSorts = ['manual', 'price-ascending', 'price-descending', 'created-descending'];
    if (knownSorts.indexOf(currentSort) === -1) currentSort = 'manual';
    updateActiveSortOption(currentSort);
    var sortLabelEl = document.getElementById('selected-sort-text');
    if (sortLabelEl) {
      var activeOpt = document.querySelector('.sort-option[data-sort-by="' + currentSort + '"]');
      if (activeOpt) sortLabelEl.textContent = activeOpt.textContent.trim();
    }
  })();

  // Sort dropdown – AJAX: lädt sortierte Produkte ohne Seiten-Reload
  initDropdown('sort-dropdown-btn', 'sort-dropdown-menu', 'sort-dropdown-arrow', 'selected-sort-text', function (value) {
    var sortOptions = document.querySelectorAll('.sort-option[data-sort-by]');
    var sortByValue = 'manual';
    sortOptions.forEach(function (opt) {
      if (opt.textContent.trim() === value) {
        sortByValue = opt.getAttribute('data-sort-by');
      }
    });
    updateActiveSortOption(sortByValue);

    var url = window.location.pathname + '?sort_by=' + sortByValue;
    var grid = document.getElementById('product-grid-container');
    var countEl = document.getElementById('product-count');
    if (!grid) return;

    // Ladeindikator
    grid.style.opacity = '0.4';
    grid.style.pointerEvents = 'none';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid-container');
        if (newGrid) {
          grid.innerHTML = newGrid.innerHTML;
          // Re-attach add-to-cart listeners for new grid items
          attachAddToCartListeners();
        }
        var newCount = doc.getElementById('product-count');
        if (newCount && countEl) {
          countEl.textContent = newCount.textContent;
        }
        grid.style.opacity = '1';
        grid.style.pointerEvents = '';
        history.pushState(null, '', url);
      })
      .catch(function () {
        grid.style.opacity = '1';
        grid.style.pointerEvents = '';
      });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', function () {
    document.querySelectorAll('.dropdown-menu').forEach(function (m) {
      m.classList.remove('open');
      m.classList.add('hidden');
    });
    document.querySelectorAll('#dropdown-arrow, #sort-dropdown-arrow').forEach(function (a) {
      a.style.transform = 'rotate(0deg)';
    });
  });

  // -----------------------------------------------
  // 6b. Shop – Live-Suche
  // -----------------------------------------------
  var shopSearchInput = document.getElementById('shop-search-input');
  if (shopSearchInput) {
    shopSearchInput.addEventListener('input', function () {
      var term = this.value.toLowerCase().trim();
      var cards = document.querySelectorAll('#product-grid-container .product-item');
      var noResults = document.getElementById('shop-no-results');
      var gridWrapper = document.getElementById('product-grid-wrapper');
      var visible = 0;
      cards.forEach(function (card) {
        var title = card.getAttribute('data-title') || '';
        var match = !term || title.indexOf(term) !== -1;
        card.style.display = match ? '' : 'none';
        if (match) visible++;
      });
      var countEl = document.getElementById('product-count');
      if (countEl) countEl.textContent = visible;
      if (noResults) noResults.classList.toggle('hidden', visible > 0);
      if (gridWrapper) gridWrapper.classList.toggle('hidden', visible === 0);
    });
  }

  // -----------------------------------------------
  // 7. Product Detail Page – Image Gallery (Swipe + Thumbnails)
  // -----------------------------------------------
  var slidesEl   = document.getElementById('pdp-slides');
  var counterEl  = document.getElementById('pdp-slide-counter');
  var thumbArr   = Array.from(document.querySelectorAll('.pdp-thumb'));
  var slideCount = thumbArr.length;
  var mainImg    = null; // kein einzelnes mainImg mehr – Slides-Container übernimmt
  var pdpActive  = 0;

  function pdpUpdateUI(index) {
    pdpActive = index;
    if (counterEl) counterEl.textContent = (index + 1) + ' / ' + slideCount;
    thumbArr.forEach(function (t, i) {
      if (i === index) {
        t.classList.remove('border-slate-200', 'border');
        t.classList.add('border-primary', 'border-2');
        t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        t.classList.remove('border-primary', 'border-2');
        t.classList.add('border-slate-200', 'border');
      }
    });
  }

  function pdpGoToSlide(index) {
    if (!slidesEl || index < 0 || index >= slideCount) return;
    slidesEl.scrollTo({ left: index * slidesEl.offsetWidth, behavior: 'smooth' });
    pdpUpdateUI(index);
  }

  // Thumbnail-Klick → Slide wechseln
  thumbArr.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { pdpGoToSlide(i); });
  });

  // User swipet → Counter + Thumbnails sofort, scrollIntoView debounced
  if (slidesEl) {
    var pdpScrollTimer;
    slidesEl.addEventListener('scroll', function () {
      var w = slidesEl.offsetWidth;
      if (!w) return;
      var idx = Math.round(slidesEl.scrollLeft / w);

      // Counter + Thumbnail-Border: sofort
      if (counterEl) counterEl.textContent = (idx + 1) + ' / ' + slideCount;
      if (idx !== pdpActive) {
        pdpActive = idx;
        thumbArr.forEach(function (t, i) {
          if (i === idx) {
            t.classList.remove('border-slate-200', 'border');
            t.classList.add('border-primary', 'border-2');
          } else {
            t.classList.remove('border-primary', 'border-2');
            t.classList.add('border-slate-200', 'border');
          }
        });
      }

      // Thumbnail-Strip scrollen: debounced (verhindert Konflikt mit Haupt-Swipe)
      clearTimeout(pdpScrollTimer);
      pdpScrollTimer = setTimeout(function () {
        var active = thumbArr[pdpActive];
        if (active) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }, 120);
    });
  }

  // -----------------------------------------------
  // 7b. Product Detail Page – Lightbox (Großansicht + Swipe + Arrows + Keyboard)
  // -----------------------------------------------
  var lightboxEl      = document.getElementById('pdp-lightbox');
  var lightboxSlides  = document.getElementById('pdp-lightbox-slides');
  var lightboxCounter = document.getElementById('pdp-lightbox-counter');
  var lightboxClose   = document.getElementById('pdp-lightbox-close');
  var lightboxPrev    = document.getElementById('pdp-lightbox-prev');
  var lightboxNext    = document.getElementById('pdp-lightbox-next');
  var lightboxBackdrop = document.getElementById('pdp-lightbox-backdrop');

  if (lightboxEl && lightboxSlides && slidesEl) {
    var lightboxCount   = lightboxSlides.children.length;
    var lightboxActive  = 0;
    var lightboxTrigger = null;

    function lightboxUpdateCounter(index) {
      lightboxActive = index;
      if (lightboxCounter) lightboxCounter.textContent = (index + 1) + ' / ' + lightboxCount;
    }

    function lightboxGoTo(index, smooth) {
      if (index < 0 || index >= lightboxCount) return;
      lightboxSlides.scrollTo({
        left: index * lightboxSlides.offsetWidth,
        behavior: smooth ? 'smooth' : 'auto'
      });
      lightboxUpdateCounter(index);
    }

    function openLightbox(startIndex) {
      lightboxTrigger = document.activeElement;
      document.body.style.overflow = 'hidden';
      lightboxEl.classList.add('is-open');
      lightboxEl.setAttribute('aria-hidden', 'false');
      // Erst sichtbar machen, dann ohne Animation zum Start-Slide springen
      requestAnimationFrame(function () {
        lightboxGoTo(startIndex || 0, false);
        if (lightboxClose) lightboxClose.focus();
      });
    }

    function closeLightbox() {
      lightboxEl.classList.remove('is-open');
      lightboxEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Fokus zurück auf das auslösende Bild / Slide-Container
      if (lightboxTrigger && typeof lightboxTrigger.focus === 'function') {
        lightboxTrigger.focus();
      }
    }

    // Klick auf Hauptbild → Lightbox öffnen
    slidesEl.addEventListener('click', function () {
      openLightbox(pdpActive);
    });

    // Schließen: X-Button, Backdrop, Escape
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxBackdrop) lightboxBackdrop.addEventListener('click', closeLightbox);

    // Klick auf Slide-Container ausserhalb des Bildes schliesst ebenfalls
    lightboxSlides.addEventListener('click', function (e) {
      if (e.target.tagName !== 'IMG') closeLightbox();
    });

    // Arrow-Buttons
    if (lightboxPrev) lightboxPrev.addEventListener('click', function () {
      lightboxGoTo(lightboxActive - 1, true);
    });
    if (lightboxNext) lightboxNext.addEventListener('click', function () {
      lightboxGoTo(lightboxActive + 1, true);
    });

    // Swipe/Scroll-Sync: Counter aktualisieren
    var lightboxScrollTimer;
    lightboxSlides.addEventListener('scroll', function () {
      clearTimeout(lightboxScrollTimer);
      lightboxScrollTimer = setTimeout(function () {
        var w = lightboxSlides.offsetWidth;
        if (!w) return;
        var idx = Math.round(lightboxSlides.scrollLeft / w);
        if (idx !== lightboxActive) lightboxUpdateCounter(idx);
      }, 60);
    });

    // Tastatur: Escape schließt, ←/→ wechselt (nur wenn offen)
    document.addEventListener('keydown', function (e) {
      if (!lightboxEl.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        lightboxGoTo(lightboxActive - 1, true);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        lightboxGoTo(lightboxActive + 1, true);
      }
    });

    // Resize: aktiven Slide neu anscrollen, um Misalignment zu verhindern
    window.addEventListener('resize', function () {
      if (!lightboxEl.classList.contains('is-open')) return;
      lightboxGoTo(lightboxActive, false);
    });
  }

  // -----------------------------------------------
  // 8. Kontaktformular – EmailJS + reCAPTCHA v3
  // -----------------------------------------------
  var contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var nameVal    = document.getElementById('cf-name');
      var emailVal   = document.getElementById('cf-email');
      var messageVal = document.getElementById('cf-message');

      if (!nameVal.value.trim() || !emailVal.value.trim() || !messageVal.value.trim()) {
        nameVal.classList.toggle('border-red-400', !nameVal.value.trim());
        emailVal.classList.toggle('border-red-400', !emailVal.value.trim());
        messageVal.classList.toggle('border-red-400', !messageVal.value.trim());
        return;
      }

      var submitBtn  = document.getElementById('cf-submit');
      var btnText    = document.getElementById('cf-btn-text');
      var btnIcon    = document.getElementById('cf-btn-icon');
      var spinner    = document.getElementById('cf-spinner');
      var successBox = document.getElementById('cf-success');
      var errorBox   = document.getElementById('cf-error');

      submitBtn.disabled = true;
      btnText.textContent = 'Wird gesendet...';
      btnIcon.classList.add('hidden');
      spinner.classList.remove('hidden');
      successBox.classList.add('hidden');
      successBox.classList.remove('flex');
      errorBox.classList.add('hidden');
      errorBox.classList.remove('flex');

      var phoneVal = document.getElementById('cf-phone');
      var phone = phoneVal && phoneVal.value.trim() ? phoneVal.value.trim() : 'Nicht angegeben';

      if (typeof grecaptcha === 'undefined' || typeof emailjs === 'undefined') {
        errorBox.classList.remove('hidden');
        errorBox.classList.add('flex');
        errorBox.querySelector('p') && (errorBox.querySelector('p').textContent = 'Bitte akzeptieren Sie "Externe Dienste" in den Cookie-Einstellungen, um das Kontaktformular nutzen zu können.');
        submitBtn.disabled = false;
        btnText.textContent = 'Anfrage unverbindlich senden';
        btnIcon.classList.remove('hidden');
        spinner.classList.add('hidden');
        return;
      }

      grecaptcha.ready(function () {
        grecaptcha.execute('6LcQJZwsAAAAAK5VGAYNnAZpDhsZ-fKsy9uGZyHA', { action: 'contact' })
          .then(function (token) {
            var templateParams = {
              Firma_Name: nameVal.value.trim(),
              Email: emailVal.value.trim(),
              Telefonnummer_oder_Nicht_Angegeben: phone,
              Nachricht: messageVal.value.trim(),
              'g-recaptcha-response': token
            };

            emailjs.send('service_epxwk58', 'template_s20c3yk', templateParams)
              .then(function () {
                successBox.classList.remove('hidden');
                successBox.classList.add('flex');
                contactForm.reset();
                [nameVal, emailVal, messageVal].forEach(function (f) {
                  f.classList.remove('border-red-400');
                });
              })
              .catch(function () {
                errorBox.classList.remove('hidden');
                errorBox.classList.add('flex');
              })
              .finally(function () {
                submitBtn.disabled = false;
                btnText.textContent = 'Anfrage unverbindlich senden';
                btnIcon.classList.remove('hidden');
                spinner.classList.add('hidden');
              });
          })
          .catch(function () {
            errorBox.classList.remove('hidden');
            errorBox.classList.add('flex');
            submitBtn.disabled = false;
            btnText.textContent = 'Anfrage unverbindlich senden';
            btnIcon.classList.remove('hidden');
            spinner.classList.add('hidden');
          });
      });
    });

    // Rote Border entfernen wenn Nutzer tippt
    ['cf-name', 'cf-email', 'cf-message'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.addEventListener('input', function () {
          this.classList.remove('border-red-400');
        });
      }
    });
  }

  // Quantity selector on PDP
  var qtyInput = document.getElementById('pdp-qty');
  var qtyMinus = document.getElementById('pdp-qty-minus');
  var qtyPlus  = document.getElementById('pdp-qty-plus');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', function () {
      var v   = parseInt(qtyInput.value, 10);
      var max = qtyInput.max !== '' ? parseInt(qtyInput.max, 10) : Infinity;
      if (v < max) qtyInput.value = v + 1;
    });
  }

  // Add-to-cart on PDP – Shopify AJAX
  var pdpCartBtn = document.getElementById('pdp-add-to-cart');
  if (pdpCartBtn) {
    pdpCartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      addToCart(variantId, qty, this);
    });
  }

  // Multi-Option Varianten-Auswahl auf PDP (Größe, Modell, Farbe …)
  var productVariantsEl = document.getElementById('product-variants-json');
  if (productVariantsEl && pdpCartBtn) {
    var allVariants    = JSON.parse(productVariantsEl.textContent);
    var optSelectors   = document.querySelectorAll('.option-selector');
    var selectedOpts   = {};

    // Initiale Auswahl aus dem Markup lesen (erste Buttons)
    optSelectors.forEach(function (sel) {
      var idx  = sel.getAttribute('data-option-index');
      var first = sel.querySelector('.option-btn[aria-pressed="true"]');
      if (first) selectedOpts[idx] = first.getAttribute('data-option-value');
    });

    function findVariant() {
      return allVariants.find(function (v) {
        return Object.keys(selectedOpts).every(function (idx) {
          return v['option' + (parseInt(idx, 10) + 1)] === selectedOpts[idx];
        });
      }) || null;
    }

    var allPrices = (function () {
      var el = document.getElementById('product-prices-json');
      return el ? JSON.parse(el.textContent) : {};
    }());

    var stockStatusEl  = document.getElementById('pdp-stock-status');
    var soldOutBtn     = document.getElementById('pdp-sold-out-btn');
    var buyNowWrapper  = document.getElementById('pdp-buy-now-wrapper');

    var STOCK_IN  = '<span class="relative flex h-3 w-3"><span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span><span class="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span></span><span class="text-sm font-bold text-green-600 tracking-wide">Auf Lager</span>';
    var STOCK_OUT = '<span class="relative flex h-3 w-3"><span class="relative inline-flex rounded-full h-3 w-3 bg-red-400"></span></span><span class="text-sm font-bold text-red-500 tracking-wide">Ausverkauft</span>';

    function applyVariant(variant) {
      var priceEl      = document.getElementById('pdp-price');
      var compareEl    = document.getElementById('pdp-compare-price');
      var saveBadge    = document.getElementById('pdp-save-badge');
      var buyNowInput  = document.getElementById('pdp-buy-now-variant-id');
      var available    = variant ? variant.available : false;

      // Add-to-Cart / Ausverkauft-Button tauschen
      if (available) {
        pdpCartBtn.classList.remove('hidden');
        if (soldOutBtn)    soldOutBtn.classList.add('hidden');
        if (buyNowWrapper) buyNowWrapper.classList.remove('hidden');
      } else {
        pdpCartBtn.classList.add('hidden');
        if (soldOutBtn)    soldOutBtn.classList.remove('hidden');
        if (buyNowWrapper) buyNowWrapper.classList.add('hidden');
      }

      // Lagerstatus-Anzeige
      if (stockStatusEl) stockStatusEl.innerHTML = available ? STOCK_IN : STOCK_OUT;

      if (variant) {
        pdpCartBtn.setAttribute('data-variant-id', String(variant.id));
        if (buyNowInput) buyNowInput.value = variant.id;

        // Maximale Menge anhand des Lagerbestands begrenzen
        if (qtyInput) {
          var tracked = variant.inventory_management === 'shopify';
          var deny    = variant.inventory_policy === 'deny';
          var stock   = variant.inventory_quantity;
          if (tracked && deny && typeof stock === 'number' && stock > 0) {
            qtyInput.max = stock;
            if (parseInt(qtyInput.value, 10) > stock) qtyInput.value = stock;
          } else {
            qtyInput.removeAttribute('max');
          }
        }

        // Preis aktualisieren
        var pd = allPrices[variant.id];
        if (pd && priceEl) {
          priceEl.textContent = pd.price;
          if (pd.has_compare) {
            if (compareEl) { compareEl.textContent = pd.compare_at_price; compareEl.classList.remove('hidden'); }
            if (saveBadge) { saveBadge.textContent = '-' + pd.save_percent + '%'; saveBadge.classList.remove('hidden'); }
            priceEl.classList.remove('text-on-surface'); priceEl.classList.add('text-primary');
          } else {
            if (compareEl) compareEl.classList.add('hidden');
            if (saveBadge) saveBadge.classList.add('hidden');
            priceEl.classList.remove('text-primary'); priceEl.classList.add('text-on-surface');
          }
        }

        // Varianten-Bild wechseln → zum passenden Slide scrollen
        // Weg 1: Bild direkt der Variante zugewiesen (Shopify Admin → Variante → Bild)
        if (variant.featured_image) {
          var imgId      = String(variant.featured_image.id);
          var matchThumb = document.querySelector('.pdp-thumb[data-image-id="' + imgId + '"]');
          if (matchThumb) {
            var matchIdx = thumbArr.indexOf(matchThumb);
            if (matchIdx >= 0) { pdpGoToSlide(matchIdx); }
          }
        } else {
          // Weg 2: Bild-Alt-Text stimmt mit einem Optionswert überein
          // (Admin → Produkt → Bild bearbeiten → Alt-Text = z.B. "Modell A")
          var optVals = [variant.option1, variant.option2, variant.option3]
            .filter(Boolean)
            .map(function (v) { return v.toLowerCase().trim(); });
          if (optVals.length) {
            var altIdx = thumbArr.findIndex(function (t) {
              var alt = t.getAttribute('data-alt') || '';
              return alt && optVals.indexOf(alt) >= 0;
            });
            if (altIdx >= 0) pdpGoToSlide(altIdx);
          }
        }
      }
    }

    // Nicht-verfügbare Optionswerte ausgegraut markieren
    function updateOptionAvailability() {
      optSelectors.forEach(function (sel) {
        var idx = sel.getAttribute('data-option-index');
        sel.querySelectorAll('.option-btn').forEach(function (btn) {
          var val = btn.getAttribute('data-option-value');
          var hasAvailable = allVariants.some(function (v) {
            if (!v.available) return false;
            // Prüfen ob diese Option + alle anderen ausgewählten Optionen → verfügbare Variante
            return v['option' + (parseInt(idx, 10) + 1)] === val &&
              Object.keys(selectedOpts).every(function (otherIdx) {
                if (otherIdx === idx) return true;
                return v['option' + (parseInt(otherIdx, 10) + 1)] === selectedOpts[otherIdx];
              });
          });
          if (hasAvailable) {
            btn.disabled = false;
            btn.classList.remove('opacity-40', 'line-through', 'cursor-not-allowed');
          } else {
            btn.disabled = true;
            btn.classList.add('opacity-40', 'line-through', 'cursor-not-allowed');
          }
        });
      });
    }

    optSelectors.forEach(function (sel) {
      sel.querySelectorAll('.option-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = this.getAttribute('data-option-index');
          var val = this.getAttribute('data-option-value');

          // Buttons dieser Gruppe zurücksetzen
          sel.querySelectorAll('.option-btn').forEach(function (b) {
            b.classList.remove('border-[#111827]', 'bg-[#111827]', 'text-white');
            b.classList.add('border-slate-200', 'text-on-surface');
            b.setAttribute('aria-pressed', 'false');
          });
          this.classList.add('border-[#111827]', 'bg-[#111827]', 'text-white');
          this.classList.remove('border-slate-200', 'text-on-surface');
          this.setAttribute('aria-pressed', 'true');

          selectedOpts[idx] = val;
          updateOptionAvailability();
          applyVariant(findVariant());
        });
      });
    });

    // Initiales Update
    updateOptionAvailability();
    applyVariant(findVariant());
  }

  // -----------------------------------------------
  // 9. Native Carousel Logic (Empfehlungen)
  // -----------------------------------------------
  var carousel = document.getElementById('native-carousel');

  if (carousel) {
    var isCarouselInitialized = false;
    var carouselCards = [];
    var originalCardCount = carousel.querySelectorAll('.carousel-card').length;

    var updateCenterCard = function () {
      if (carousel.offsetWidth === 0) return;
      var containerCenter = carousel.scrollLeft + (carousel.clientWidth / 2);

      var closestCard = null;
      var minDistance = Infinity;

      carouselCards.forEach(function (card) {
        var cardCenter = card.offsetLeft + (card.offsetWidth / 2);
        var distance = Math.abs(containerCenter - cardCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closestCard = card;
        }
      });

      carouselCards.forEach(function (card) {
        if (card === closestCard) {
          if (!card.classList.contains('is-center')) {
            card.classList.add('is-center');
            var btn = card.querySelector('span.mt-auto');
            if (btn) {
              btn.classList.remove('bg-slate-50', 'text-slate-700');
              btn.classList.add('bg-primary', 'text-white', 'shadow-md');
            }
          }
        } else {
          if (card.classList.contains('is-center')) {
            card.classList.remove('is-center');
            var btn = card.querySelector('span.mt-auto');
            if (btn) {
              btn.classList.add('bg-slate-50', 'text-slate-700');
              btn.classList.remove('bg-primary', 'text-white', 'shadow-md');
            }
          }
        }
      });
    };

    var initCarousel = function () {
      if (window.innerWidth >= 1024) return;
      if (isCarouselInitialized) return;
      if (originalCardCount === 0) return;

      var originalCardsHTML = carousel.innerHTML;
      carousel.innerHTML = originalCardsHTML.repeat(12);
      carouselCards = Array.from(carousel.querySelectorAll('.carousel-card'));

      setTimeout(function () {
        var startCard = carouselCards[Math.floor(carouselCards.length / 2)];
        if (startCard) {
          carousel.scrollLeft = startCard.offsetLeft - (carousel.clientWidth / 2) + (startCard.offsetWidth / 2);
          updateCenterCard();
        }
      }, 50);

      isCarouselInitialized = true;
    };

    initCarousel();
    window.addEventListener('resize', function () {
      if (window.innerWidth < 1024) {
        initCarousel();
      }
    });

    var isScrollingTimeout;
    carousel.addEventListener('scroll', function () {
      if (window.innerWidth >= 1024) return;

      requestAnimationFrame(updateCenterCard);

      window.clearTimeout(isScrollingTimeout);
      isScrollingTimeout = setTimeout(function () {
        if (carousel.scrollLeft < 500 || carousel.scrollLeft > (carousel.scrollWidth - carousel.clientWidth - 500)) {
          var containerCenter = carousel.scrollLeft + (carousel.clientWidth / 2);
          var activeCard = carouselCards[0];
          var minDist = Infinity;
          carouselCards.forEach(function (card) {
            var dist = Math.abs((card.offsetLeft + card.offsetWidth / 2) - containerCenter);
            if (dist < minDist) { minDist = dist; activeCard = card; }
          });

          if (activeCard) {
            var cardIndexInOriginal = Array.from(carouselCards).indexOf(activeCard) % originalCardCount;
            var middleSetStartIndex = Math.floor(carouselCards.length / 2) - Math.floor(originalCardCount / 2);
            var newTargetCard = carouselCards[middleSetStartIndex + cardIndexInOriginal];

            carousel.style.scrollBehavior = 'auto';
            carousel.scrollLeft = newTargetCard.offsetLeft - (carousel.clientWidth / 2) + (newTargetCard.offsetWidth / 2);

            setTimeout(function () { carousel.style.scrollBehavior = 'smooth'; }, 50);
          }
        }
      }, 150);
    });
  }

  // -----------------------------------------------
  // 10. Cookie Consent Banner (DSGVO)
  // -----------------------------------------------
  var cookieBanner = document.getElementById('cookie-banner');

  if (cookieBanner) {
    var acceptAllBtn     = document.getElementById('cookie-accept-all');
    var essentialOnlyBtn = document.getElementById('cookie-essential-only');
    var settingsBtn      = document.getElementById('cookie-settings-btn');
    var saveSettingsBtn  = document.getElementById('cookie-save-settings');
    var detailsPanel     = document.getElementById('cookie-details');
    var marketingToggle  = document.getElementById('cookie-marketing-toggle');
    var footerCookieBtn  = document.getElementById('footer-cookie-settings');

    function getCookieConsent() {
      try {
        var val = localStorage.getItem('eka_cookie_consent');
        return val ? JSON.parse(val) : null;
      } catch (e) { return null; }
    }

    function setCookieConsent(consent) {
      consent.timestamp = new Date().toISOString();
      localStorage.setItem('eka_cookie_consent', JSON.stringify(consent));
    }

    function showBanner() {
      cookieBanner.classList.remove('translate-y-full', 'opacity-0', 'pointer-events-none');
      cookieBanner.classList.add('translate-y-0', 'opacity-100', 'pointer-events-auto');
    }

    function hideBanner() {
      cookieBanner.classList.add('translate-y-full', 'opacity-0', 'pointer-events-none');
      cookieBanner.classList.remove('translate-y-0', 'opacity-100', 'pointer-events-auto');
      // Details-Panel schließen
      if (detailsPanel) detailsPanel.style.gridTemplateRows = '0fr';
    }

    function loadScript(src, callback) {
      if (document.querySelector('script[src="' + src + '"]')) { if (callback) callback(); return; }
      var s = document.createElement('script');
      s.src = src;
      s.onload = callback || function(){};
      document.head.appendChild(s);
    }

    function applyConsent(consent) {
      // Shopify Customer Privacy API
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: false,
          marketing: consent.marketing,
          preferences: true
        }, function () {});
      }

      // EmailJS + reCAPTCHA nur laden wenn "Externe Dienste" (marketing) akzeptiert
      if (consent.marketing) {
        loadScript('https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js', function() {
          if (window.emailjs) emailjs.init('IVcWYl_I1x6TFTuHl');
        });
        loadScript('https://www.google.com/recaptcha/api.js?render=6LcQJZwsAAAAAK5VGAYNnAZpDhsZ-fKsy9uGZyHA');
      }
    }

    // Banner zeigen wenn noch keine Einwilligung
    var existingConsent = getCookieConsent();
    if (!existingConsent) {
      setTimeout(showBanner, 800);
    } else {
      applyConsent(existingConsent);
    }

    // Alle akzeptieren
    if (acceptAllBtn) {
      acceptAllBtn.addEventListener('click', function () {
        var consent = { essential: true, analytics: false, marketing: true };
        setCookieConsent(consent);
        applyConsent(consent);
        hideBanner();
      });
    }

    // Alle ablehnen (nur essenzielle)
    if (essentialOnlyBtn) {
      essentialOnlyBtn.addEventListener('click', function () {
        var consent = { essential: true, analytics: false, marketing: false };
        setCookieConsent(consent);
        applyConsent(consent);
        hideBanner();
      });
    }

    // Einstellungen aufklappen
    if (settingsBtn) {
      settingsBtn.addEventListener('click', function () {
        var isOpen = detailsPanel.style.gridTemplateRows === '1fr';
        detailsPanel.style.gridTemplateRows = isOpen ? '0fr' : '1fr';
        var c = getCookieConsent();
        if (c && marketingToggle) marketingToggle.checked = c.marketing;
      });
    }

    // Auswahl speichern
    if (saveSettingsBtn) {
      saveSettingsBtn.addEventListener('click', function () {
        var consent = {
          essential: true,
          analytics: false,
          marketing: marketingToggle ? marketingToggle.checked : false
        };
        setCookieConsent(consent);
        applyConsent(consent);
        hideBanner();
      });
    }

    // Footer-Link: Cookie-Einstellungen erneut öffnen
    if (footerCookieBtn) {
      footerCookieBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var c = getCookieConsent();
        if (c && marketingToggle) marketingToggle.checked = c.marketing;
        detailsPanel.style.gridTemplateRows = '1fr';
        showBanner();
        cookieBanner.scrollIntoView({ behavior: 'smooth', block: 'end' });
      });
    }
  }

  // -----------------------------------------------
  // 11. Speditionsversand – Gewichtslimit & Modal
  // -----------------------------------------------

  var weightLimitEnabled = window.EkaCare && window.EkaCare.weightLimitEnabled;
  var weightLimitGrams = (window.EkaCare && window.EkaCare.weightLimitGrams) || 100000;

  function calculateCartWeight(items) {
    var totalGrams = 0;
    if (items) {
      items.forEach(function (item) {
        totalGrams += (item.grams || 0) * item.quantity;
      });
    }
    return totalGrams;
  }

  function formatWeight(grams) {
    return (grams / 1000).toFixed(2).replace('.', ',');
  }

  function checkWeightLimit(cart) {
    if (!weightLimitEnabled) return;
    if (!cart || !cart.items) return;

    var totalGrams = calculateCartWeight(cart.items);
    liveCartWeight = totalGrams;
    var isOverweight = totalGrams > weightLimitGrams;

    var warningEl = document.getElementById('cart-weight-warning');
    var checkoutBtn = document.getElementById('cart-checkout-btn');
    var speditionBtn = document.getElementById('cart-spedition-btn');
    var weightDisplay = document.getElementById('cart-weight-display');
    var limitDisplay = document.getElementById('cart-weight-limit-display');

    if (weightDisplay) weightDisplay.textContent = formatWeight(totalGrams);
    if (limitDisplay) limitDisplay.textContent = formatWeight(weightLimitGrams);

    if (isOverweight) {
      if (warningEl) { warningEl.classList.remove('hidden'); warningEl.classList.add('flex'); }
      if (checkoutBtn) checkoutBtn.classList.add('hidden');
      if (speditionBtn) { speditionBtn.classList.remove('hidden'); speditionBtn.classList.add('flex'); }
    } else {
      if (warningEl) { warningEl.classList.add('hidden'); warningEl.classList.remove('flex'); }
      if (checkoutBtn) checkoutBtn.classList.remove('hidden');
      if (speditionBtn) { speditionBtn.classList.add('hidden'); speditionBtn.classList.remove('flex'); }
    }
  }

  // --- Modal Open / Close ---

  var speditionModal = document.getElementById('spedition-modal');
  var speditionPanel = document.getElementById('spedition-panel');
  var speditionCloseBtn = document.getElementById('spedition-close-btn');
  var speditionBackdrop = document.getElementById('spedition-backdrop');
  var currentCartItems = [];

  function openSpeditionModal(cart) {
    currentCartItems = (cart && cart.items) ? cart.items : [];
    var totalGrams = calculateCartWeight(currentCartItems);
    var totalWeightEl = document.getElementById('spedition-total-weight');
    var limitWeightEl = document.getElementById('spedition-limit-weight');
    if (totalWeightEl) totalWeightEl.textContent = formatWeight(totalGrams) + ' kg';
    if (limitWeightEl) limitWeightEl.textContent = formatWeight(weightLimitGrams);

    if (speditionModal) {
      document.body.style.overflow = 'hidden';
      speditionModal.classList.remove('pointer-events-none', 'opacity-0');
      speditionModal.classList.add('pointer-events-auto', 'opacity-100');
      speditionModal.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        if (speditionPanel) {
          speditionPanel.style.transform = 'translateY(0) scale(1)';
        }
      });
    }
  }

  function closeSpeditionModal() {
    if (speditionPanel) {
      speditionPanel.style.transform = 'translateY(8px) scale(0.97)';
    }
    if (speditionModal) {
      speditionModal.classList.add('opacity-0');
      speditionModal.setAttribute('aria-hidden', 'true');
      setTimeout(function () {
        speditionModal.classList.add('pointer-events-none');
        speditionModal.classList.remove('pointer-events-auto', 'opacity-100');
        document.body.style.overflow = '';
      }, 500);
    }
  }

  // Spedition-Button im Cart Drawer
  var cartSpeditionBtn = document.getElementById('cart-spedition-btn');
  if (cartSpeditionBtn) {
    cartSpeditionBtn.addEventListener('click', function () {
      fetchCart(function (cart) {
        openSpeditionModal(cart);
      });
    });
  }

  if (speditionCloseBtn) speditionCloseBtn.addEventListener('click', closeSpeditionModal);
  if (speditionBackdrop) speditionBackdrop.addEventListener('click', closeSpeditionModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && speditionModal && !speditionModal.classList.contains('pointer-events-none')) {
      closeSpeditionModal();
    }
  });

  // --- Produkt-Chips ---

  var speditionProducts = [];

  function renderSpeditionProducts() {
    var container = document.getElementById('sf-products-container');
    if (!container) return;

    if (speditionProducts.length === 0) {
      container.innerHTML = '<p class="text-slate-500 text-xs italic">Noch keine Produkte hinzugefügt.</p>';
      return;
    }

    var html = '';
    speditionProducts.forEach(function (p, index) {
      var imgHtml = p.image
        ? '<img src="' + p.image + '" class="w-8 h-8 rounded object-cover" alt="">'
        : '<span class="material-symbols-outlined text-slate-400 text-[20px]">inventory_2</span>';
      var subtitle = '';
      if (p.variant) subtitle += p.variant;
      subtitle += (subtitle ? ' \u00B7 ' : '') + p.quantity + 'x';
      if (p.grams > 0) subtitle += ' \u00B7 ' + formatWeight(p.grams * p.quantity) + ' kg';

      html += '<div class="sf-product-chip flex items-center gap-2 bg-slate-600/50 border border-slate-500/50 rounded-lg px-3 py-2 text-white text-xs opacity-0 translate-y-2" data-index="' + index + '">'
        + '<div class="w-8 h-8 rounded flex items-center justify-center shrink-0 overflow-hidden">' + imgHtml + '</div>'
        + '<div class="flex flex-col min-w-0">'
        + '<span class="font-bold truncate">' + p.title + '</span>'
        + '<span class="text-slate-400 text-[10px]">' + subtitle + '</span>'
        + '</div>'
        + '<button type="button" class="sf-remove-chip ml-auto w-5 h-5 flex items-center justify-center rounded-full hover:bg-red-500/30 text-slate-400 hover:text-red-400 transition-colors shrink-0" data-index="' + index + '">'
        + '<span class="material-symbols-outlined text-[14px]">close</span>'
        + '</button></div>';
    });
    container.innerHTML = html;

    // Gestaffelte Einblend-Animation
    container.querySelectorAll('.sf-product-chip').forEach(function (chip, i) {
      setTimeout(function () {
        chip.classList.remove('opacity-0', 'translate-y-2');
        chip.classList.add('opacity-100', 'translate-y-0');
      }, 50 + i * 60);
    });

    // Entfernen-Handler
    container.querySelectorAll('.sf-remove-chip').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-index'), 10);
        speditionProducts.splice(idx, 1);
        renderSpeditionProducts();
      });
    });
  }

  // Warenkorb uebernehmen (1-Klick)
  var loadCartBtn = document.getElementById('sf-load-cart-btn');
  if (loadCartBtn) {
    loadCartBtn.addEventListener('click', function () {
      speditionProducts = currentCartItems.map(function (item) {
        return {
          title: item.product_title,
          variant: item.variant_title !== 'Default Title' ? item.variant_title : '',
          quantity: item.quantity,
          grams: item.grams || 0,
          image: item.image || null
        };
      });
      renderSpeditionProducts();
    });
  }

  // Manuell hinzufuegen
  var sfAddBtn = document.getElementById('sf-add-product-btn');
  var sfManualInput = document.getElementById('sf-manual-product');
  if (sfAddBtn && sfManualInput) {
    function addManualProduct() {
      var val = sfManualInput.value.trim();
      if (!val) return;
      speditionProducts.push({
        title: val, variant: '', quantity: 1, grams: 0, image: null
      });
      sfManualInput.value = '';
      renderSpeditionProducts();
    }
    sfAddBtn.addEventListener('click', addManualProduct);
    sfManualInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); addManualProduct(); }
    });
  }

  // --- Formular absenden (EmailJS) ---

  var speditionForm = document.getElementById('spedition-form');
  if (speditionForm) {
    speditionForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var nameVal = document.getElementById('sf-name');
      var emailVal = document.getElementById('sf-email');
      var phoneVal = document.getElementById('sf-phone');
      var messageVal = document.getElementById('sf-message');
      var submitBtn = document.getElementById('sf-submit');
      var btnText = document.getElementById('sf-btn-text');
      var btnIcon = document.getElementById('sf-btn-icon');
      var spinner = document.getElementById('sf-spinner');
      var successBox = document.getElementById('sf-success');
      var errorBox = document.getElementById('sf-error');

      // Validierung
      var valid = true;
      if (!nameVal.value.trim()) { nameVal.classList.add('border-red-400'); valid = false; }
      if (!emailVal.value.trim()) { emailVal.classList.add('border-red-400'); valid = false; }
      if (speditionProducts.length === 0) {
        var pc = document.getElementById('sf-products-container');
        if (pc) { pc.classList.add('border-red-400'); setTimeout(function () { pc.classList.remove('border-red-400'); }, 2000); }
        valid = false;
      }
      if (!valid) return;

      submitBtn.disabled = true;
      btnText.textContent = 'Wird gesendet\u2026';
      btnIcon.classList.add('hidden');
      spinner.classList.remove('hidden');
      successBox.classList.add('hidden'); successBox.classList.remove('flex');
      errorBox.classList.add('hidden'); errorBox.classList.remove('flex');

      var phone = phoneVal && phoneVal.value.trim() ? phoneVal.value.trim() : 'Nicht angegeben';

      // Produktliste als Text
      var productLines = speditionProducts.map(function (p) {
        var line = p.title;
        if (p.variant) line += ' (' + p.variant + ')';
        line += ' \u2013 ' + p.quantity + 'x';
        if (p.grams > 0) line += ' \u2013 ' + formatWeight(p.grams * p.quantity) + ' kg';
        return line;
      });

      var totalGrams = 0;
      speditionProducts.forEach(function (p) { totalGrams += (p.grams || 0) * p.quantity; });

      // Cookie-Check
      if (typeof grecaptcha === 'undefined' || typeof emailjs === 'undefined') {
        errorBox.querySelector('p').textContent = 'Bitte akzeptieren Sie "Externe Dienste" in den Cookie-Einstellungen, um das Formular nutzen zu können.';
        errorBox.classList.remove('hidden'); errorBox.classList.add('flex');
        submitBtn.disabled = false;
        btnText.textContent = 'Speditionsanfrage senden';
        btnIcon.classList.remove('hidden');
        spinner.classList.add('hidden');
        return;
      }

      function resetSubmitBtn() {
        submitBtn.disabled = false;
        btnText.textContent = 'Speditionsanfrage senden';
        btnIcon.classList.remove('hidden');
        spinner.classList.add('hidden');
      }

      grecaptcha.ready(function () {
        grecaptcha.execute('6LcQJZwsAAAAAK5VGAYNnAZpDhsZ-fKsy9uGZyHA', { action: 'spedition' })
          .then(function (token) {
            return emailjs.send('service_epxwk58', 'template_SPEDITION', {
              Firma_Name: nameVal.value.trim(),
              Email: emailVal.value.trim(),
              Telefon: phone,
              Produkte: productLines.join('\n'),
              Anzahl_Produkte: String(speditionProducts.length),
              Gesamtgewicht_kg: formatWeight(totalGrams),
              Nachricht: messageVal ? messageVal.value.trim() : '',
              'g-recaptcha-response': token
            });
          })
          .then(function () {
            successBox.classList.remove('hidden'); successBox.classList.add('flex');
            speditionForm.reset();
            speditionProducts = [];
            renderSpeditionProducts();
            resetSubmitBtn();
          })
          .catch(function () {
            errorBox.classList.remove('hidden'); errorBox.classList.add('flex');
            resetSubmitBtn();
          });
      });
    });

    // Rote Border bei Eingabe entfernen
    ['sf-name', 'sf-email'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', function () { this.classList.remove('border-red-400'); });
    });
  }

});
